import strings from '../content/strings.json';

export type Lang = 'pl' | 'en';
export interface Localized {
  pl: string;
  en: string;
}

const STORAGE_KEY = 'moser-lang';
let lang: Lang = 'pl';
const listeners = new Set<(l: Lang) => void>();

export function detectLang(search: string, stored: string | null): Lang {
  const q = new URLSearchParams(search).get('lang');
  if (q === 'pl' || q === 'en') return q;
  return stored === 'en' ? 'en' : 'pl';
}

/** Call once at boot. */
export function initI18n(): void {
  setLang(detectLang(location.search, localStorage.getItem(STORAGE_KEY)));
}

export function getLang(): Lang {
  return lang;
}

export function setLang(l: Lang): void {
  lang = l;
  localStorage.setItem(STORAGE_KEY, l);
  document.documentElement.lang = l;
  listeners.forEach((f) => f(l));
}

export function onLangChange(f: (l: Lang) => void): void {
  listeners.add(f);
}

export function t(key: string): string {
  return (strings as Record<Lang, Record<string, string>>)[lang][key] ?? key;
}

export function pick(loc: Localized | undefined, fallback = ''): string {
  return loc?.[lang] ?? fallback;
}
